module.exports = __webpack_public_path__ + "img/support.f88e49d8.png";